import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }

import router from "@/router";
import { Authorization, LogStatus } from "@/services/authenticate";
import { useUserStore } from "@/stores/user";
import { onMounted, reactive } from "vue"; 
import { useOverviewStore } from "@/stores/overview";
import { useSettingsStore } from "@/stores/setting";
import LoadingDots from "@/components/util/LoadingDots.vue";
import image from "@/assets/ABB-logo.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const userStore = useUserStore();

const state = reactive({
    status: 0
});

onMounted(async () => {
    loggedCheck(Authorization.logStatus);
    state.status = 0;
    await Authorization.signIn();
    if (Authorization.logStatus == LogStatus.Logged) {
        state.status = 1;
        await userStore.loadUserRole();
        if (userStore.getUserRole > 0) {
            state.status = 2;
            if (userStore.getUserRole > 0) {
                await getBasicData();
                loggedCheck(Authorization.logStatus);
            }
        }
        else {
            state.status = -2;
        }
    }
    else {
        state.status = -1;
    }
});

async function getBasicData() {
    const overviewStore = useOverviewStore();
    const settingsStore = useSettingsStore();

    const promises = [
        overviewStore.loadProjectTypes(),
        overviewStore.loadNonBillableProjectType(),
        overviewStore.loadInvoiceTypes(),
        settingsStore.loadCountries(),
        settingsStore.loadDivisions(),
    ];
    await Promise.all(promises);
}

function loggedCheck(value: LogStatus) {
    if (value == LogStatus.Logged) {
        const destination = sessionStorage.getItem("log_to") ?? 'ReportHours';
        sessionStorage.removeItem("log_to");
        router.push({ name: destination == 'Login' ? 'ReportHours' : destination });
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(image),
        width: "320"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", null, [
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (state.status == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Trying to log you in..."))
              : (state.status == 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Getting your role"))
                : (state.status == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Succesfully logged, you will be redirected"))
                  : (state.status == -1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "You need to log in with ABB account"))
                    : (state.status == -2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "You don't have permission to access this application"))
                      : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(LoadingDots, { class: "loading" })
      ])
    ])
  ]))
}
}

})